import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useSubscriptionsStore } from '@stores/subscriptions'

import { toIdValue } from '@helpers/route'

import { defineNuxtRouteMiddleware } from '#app'

/**
 * Runs after `subscriptions` (which maps the query onto the shared store) and narrows the list to the
 * customer of the page — the id comes from the path, never from the query.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  useSubscriptionsStore().setFilterCustomerId(toIdValue(to.params.id))
})
